module.exports = __webpack_public_path__ + "img/slider2.5f25adeb.jpg";